import { useEffect, useState } from "react";
import { Divider, Grid, Stack, useMediaQuery, useTheme } from "@mui/material";

import NavigatorCardList from "../components/UI/HomeNavigation/NavigationCardList";
import NavigationCardsPage from "../components/UI/NavigationCardsPage";
import { useInstalledExtensions } from "../hooks/useInstalledExtensions";
import { Extension } from "../models/intalled-extensions";
import { useAppSelector } from "../store/store";
import { tokenService } from "../services/token.service";
import PagesContainer from "../components/UI/PagesContainer";

const WelcomePage = () => {
  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const [hasExtension] = useInstalledExtensions(Extension.MEDIC_GUIDE);

  const [cardInstalled] = useInstalledExtensions(Extension.CARDS);

  const [hasCardPermission, setHasCardPermission] = useState(false);

  const cardPermission = useAppSelector((state) =>
    state.privilege.privileges.find((priv) => priv.domainName === "card")
  );

  const { logoInHeader } = useAppSelector((state) => state.theme);

  useEffect(() => {
    if (tokenService.getAccessToken()) {
      if (cardInstalled && cardPermission) {
        setHasCardPermission(true);
        return;
      }
      setHasCardPermission(false);
      return;
    }
    if (!tokenService.getAccessToken() && cardInstalled) {
      setHasCardPermission(true);
      return;
    }
  }, [cardInstalled, cardPermission]);

  return (
    <>
      <PagesContainer
        disablePadding
        hideHeader
        height={matches ? "calc(100% - 5rem)" : "100%"}
      >
        <Grid container direction={"row"} width={"100%"} gap={2}>
          <Grid
            item
            xs={12}
            xl={6}
            sx={(t) => ({
              paddingInline: 2,
              [t.breakpoints.up("md")]: {
                paddingInline: logoInHeader ? 15 : 6,
              },
            })}
          >
            <Stack gap={2}>
              {hasExtension && (
                <>
                  <Divider />
                </>
              )}

              <NavigatorCardList />

              {hasCardPermission && <NavigationCardsPage />}
            </Stack>
          </Grid>
        </Grid>
      </PagesContainer>
    </>
  );
};

export default WelcomePage;
